import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const bloPedFechasApi = `${baseUrl}/bloque-pedagogico-fechas`;

export const allBlopedFechasService = async (params) => {
  const res = await axios.get(bloPedFechasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveBlopedFechasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${bloPedFechasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(bloPedFechasApi, data, { headers: token({}) });
  }
  return res;
};

export const oneBlopedFechasService = async (id) => {
  const res = await axios.get(`${bloPedFechasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteBlopedFechasService = async (id) => {
  const res = await axios.delete(`${bloPedFechasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
